import { Chip, Stack } from "@mui/material";
import { useGetPatientScoresQuery } from "src/api/services/mentalHealthApi";
import { getSeverity } from "./utils/getSeverity";
import { useMemo } from "react";

interface Props {
  patientId: number;
}

const MentalHealthScoreChip = ({ patientId }: Props) => {
  const { data: scores } = useGetPatientScoresQuery(patientId);

  const gad7Severity = useMemo(
    () => getSeverity("GAD-7", scores?.gad7 ?? 0),
    [scores?.gad7]
  );
  const phq9Severity = useMemo(
    () => getSeverity("PHQ-9", scores?.phq9 ?? 0),
    [scores?.phq9]
  );

  const gad7ChipLabel = useMemo(() => {
    if (scores?.gad7 == null || gad7Severity?.label == null) return "";

    return `GAD-7: ${scores.gad7} (${gad7Severity.label})`;
  }, [gad7Severity, scores?.gad7]);

  const phq9ChipLabel = useMemo(() => {
    if (scores?.phq9 == null || phq9Severity?.label == null) return "";

    return `PHQ-9: ${scores.phq9} (${phq9Severity.label})`;
  }, [phq9Severity?.label, scores?.phq9]);

  if (scores?.gad7 == null && scores?.phq9 == null) return null;

  return (
    <Stack direction={"row"} gap={2}>
      <Chip
        label={gad7ChipLabel}
        color={gad7Severity?.color ?? "default"}
        sx={{ fontWeight: 700 }}
      />
      <Chip
        label={phq9ChipLabel}
        color={phq9Severity?.color ?? "default"}
        sx={{ fontWeight: 700 }}
      />
    </Stack>
  );
};

export default MentalHealthScoreChip;
